// Formato mínimo para el mensaje de las notificaciones internas
// (m_notifications_internal.message). El mensaje se guarda como texto y
// admite solo:
//   **negrita**
//   [texto](https://...)
//   URLs sueltas (http/https), que se convierten en link
// Todo lo demás se escapa: nunca se interpreta HTML que venga en el mensaje.

const LINK_REGEX = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<*]+)/g
const BOLD_REGEX = /\*\*(.+?)\*\*/g
// puntuación que suele quedar pegada al final de una URL suelta
const URL_TRAILING_REGEX = /[.,;:!?)]+$/

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function anchor(href, label) {
  return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + label + '</a>'
}

// HTML seguro para v-html (vista de detalle)
export function renderNotificationMessage(message) {
  const html = escapeHtml(message || '').replace(LINK_REGEX, (match, label, href, url) => {
    if (href) return anchor(href, label)

    const trailing = (url.match(URL_TRAILING_REGEX) || [''])[0]
    const clean = url.slice(0, url.length - trailing.length)
    return anchor(clean, clean) + trailing
  })

  return html.replace(BOLD_REGEX, '<strong>$1</strong>')
}

// Texto sin marcas para las vistas previas de una línea (campana, listado)
export function plainNotificationMessage(message) {
  return (message || '')
    .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '$1')
    .replace(BOLD_REGEX, '$1')
}
